// updateStatus.js
import axiosInstance from 'services/axiosMiddleware';

export async function updateStatus(userid, status, roleid) {
  try {
    const response = await axiosInstance.put(`users/${userid}/status`, { status, roleid });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}